module.exports = __webpack_public_path__ + "static/media/trophy.9a2b5f96.svg";